import React, { useState } from 'react';
import Error from './Error'
import shortid from 'shortid'
import PropTypes from 'prop-types';

const Form = ({ saveExpenditure, saveCreateExpenditure }) => {

    const [name, saveName] = useState('');
    const [quantity, saveQuantity] = useState(0);
    const [error, saveError] = useState(false);
    // cuando el usuairo agrega un gasto
    const addExpenditure = e => {
        e.preventDefault();
        //validate
        if (quantity < 0 || isNaN(quantity) || name.trim() === '') {
            saveError(true);
            return;
        }
        saveError(false);

        //construir el gasto
        const expenditure = {
            id: shortid.generate(),
            name, // name: name si se llaman igual puede ser uno solo
            quantity
        }

        console.log(expenditure);
        // pasar el gasto al componente principal
        saveExpenditure(expenditure);
        saveCreateExpenditure(true);
        //resetear el form
        saveName('');
        saveQuantity(0);
    }

    return (
        <form
            onSubmit={addExpenditure}
        >
            <h2>Agrega tus gastos aqui</h2>

            {error ? <Error message="Ambos campos son obligatorios o presupuesto incorrecto" /> : null}

            <div className="campo">
                <label>Nombre gasto</label>
                <input
                    type="text"
                    className="u-full-width"
                    placeholder="Ej. Transporte"
                    value={name}
                    onChange={e => saveName(e.target.value)}
                />
                <label>Cantidad gasto</label>
                <input
                    type="number"
                    className="u-full-width"
                    placeholder="Ej. 300"
                    value={quantity}
                    onChange={e => saveQuantity(parseInt(e.target.value, 10))}
                />
                <input
                    type="submit"
                    className="button-primary u-full-width"
                    value="Agregar gasto"
                />
            </div>
        </form>
    );
}

Form.propTypes = {
    saveExpenditure: PropTypes.func.isRequired,
    saveCreateExpenditure: PropTypes.func.isRequired,
}

export default Form;